import React, { useRef } from "react";
import "../../css/styles.css";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const UploadExcel = ({ onFileSelected, isLoading }) => {
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (
                file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.name.endsWith(".xlsx")
            ) {
                onFileSelected(file);
            } else {
                alert("Por favor, seleccione un archivo Excel válido (.xlsx)");
            }
            event.target.value = null;
        }
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div
            style={{
                padding: "2rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #ccc",
                backgroundColor: "#fafafa",
                cursor: "pointer",
                transition: "all 0.3s ease",
            }}
            onClick={handleClick}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f0f0f0";
                e.currentTarget.style.borderColor = "#999";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fafafa";
                e.currentTarget.style.borderColor = "#ccc";
            }}
        >
            <input
                type="file"
                accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
            />
            <CloudUploadIcon sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />
            <h3 style={{ color: "gray", margin: "0 0 10px 0" }}>
                Cargar Archivo de Cierre Mensual
            </h3>
            <p style={{ color: "gray", margin: "0 0 20px 0", fontSize: "14px" }}>
                (Solo se permiten archivos .xlsx)
            </p>
            <button
                className="boton"
                onClick={(e) => {
                    e.stopPropagation();
                    handleClick();
                }}
                disabled={isLoading}
            >
                {isLoading ? "Procesando..." : "Seleccionar Excel"}
            </button>
        </div>
    );
};

export default UploadExcel;
